import React from "react";
import { Helmet } from "react-helmet-async";

// Canonical production origin for the storefront.
export const SITE_URL = "https://molecularixbiolabs.com";
const DEFAULT_IMG = `${SITE_URL}/og-image.jpg`;
const BRAND = "Molecularix Biolabs";
const DEFAULT_TITLE = `${BRAND} — Reference-Grade Research Compounds`;

/**
 * Per-route SEO: title, meta description, canonical, Open Graph, Twitter card,
 * and optional JSON-LD structured data. One <Seo/> per page.
 */
export default function Seo({ title, description, path = "", image, type = "website", jsonLd, noindex = false }) {
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMG;
  const fullTitle = title ? `${title} | ${BRAND}` : DEFAULT_TITLE;
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}
